import { FormStatus } from '../../../enum/form-status.enum';
import { Component } from '@angular/core';
import { BaseFormComponent } from '../base/base-form.component';

/**
 * 基本表單頁面的抽象類別，繼承 BaseFormComponent。
 * 設定沒有 MasterMenuBar 並直接進入編輯狀態。
 *
 * @export
 * @abstract
 * @class SimpleFormComponent
 * @extends {BaseFormComponent}
 */
@Component({
  template: ''
})

export abstract class SimpleFormComponent extends BaseFormComponent {

  /**
   * 一般編輯表單直接就是編輯狀態，不需要有 MenuBar。
   */
  override hasMasterMenuBar: boolean = false;

  /**
   * 一般編輯表單直接就是編輯狀態。
   */
  override masterFormStatus: FormStatus = FormStatus.EDIT;

  /**
   * 一般編輯表單直接就是編輯狀態，不需要有 MenuBar。
   * 所以相關的 function 都實作 return。
   */
  override async doMasterMenuSubmit(): Promise<boolean> {
    return true;
  }

  /**
   * 一般編輯表單直接就是編輯狀態，不需要有 MenuBar。
   * 所以相關的 function 都實作 return。
   */
  override async beforeMasterMenuSubmit(): Promise<boolean> {
    return true;
  }

  /**
   * 一般編輯表單直接就是編輯狀態，不需要有 MenuBar。
   * 所以相關的 function 都實作 return。
   */
  override async doMasterMenuDelete(): Promise<boolean> {
    return true;
  }

  /**
   * 一般編輯表單直接就是編輯狀態，不需要有 MenuBar。
   * 所以相關的 function 都實作 return。
   */
  override async beforeMasterMenuDiscard(): Promise<boolean> {
    return true;
  }

  /**
   * 一般編輯表單直接就是編輯狀態，不需要有 MenuBar。
   * 所以相關的 function 都實作 return。
   */
  override afterMasterMenuStatusChange(): void {
    return;
  }

  /**
   * 一般編輯表單直接就是編輯狀態，不需要有 MenuBar。
   * 所以相關的 function 都實作 return。
   */
  override initExtraMasterMenu(): void {
    return;
  }

  /**
   * 一般編輯表單直接就是編輯狀態，不需要有 MenuBar。
   * 所以相關的 function 都實作 return。
   */
  override setExtraMasterMenuStatus(): void {
    return;
  }
}
